module.exports = __webpack_public_path__ + "img/newsleft-preview.cd7fbb38.png";